<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card v-if="isLoaderActive">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>
    <v-card v-if="!isLoaderActive && groupData">
      <v-card-title>
        <span class="headline">{{ isEditMode ? "Edit " : "Add New " }} {{ type }} Group</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="field.name"
                            label="Group Name *"
                            required
                            :error="!(field.name && field.name.length) && isFormDirty" />
            </v-col>
            <v-col cols="12">
              <v-select v-model="filterTypeId"
                        :items="filterOptions"
                        label="Filter Type *"
                        @change="onFilterSelection"
                        required
                        :disabled="isEditMode" />
            </v-col>
            <dynamic-group-filters-editor :filter-type-id="filterTypeId"
                                          :filter-fields="groupData.GroupDataFilters"
                                          :all-filter-options="filterOptions"
                                          :group="groupData"
                                          @update-filters="_onFilterUpdate" />
          </v-row>
        </v-container>
        <small>* Indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="close">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="submit">
          {{ isEditMode ? "Update" : "Add" }}
        </v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar">
        {{ notification }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import Api from "../../../shared-module/api";
  import DynamicGroupFiltersEditor from "../../../shared-module/entities/dynamic-group/components/dynamic-group-filters-editor/dynamic-group-filters-editor.vue";
  import FilterEditorHelperMethods from "../../../shared-module/entities/dynamic-group/components/dynamic-group-filters-editor/filter-editor-helper-methods"

  export default {
    name: "DynamicGroupAddEditDialog",
    components: {
      DynamicGroupFiltersEditor
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      isEditMode: {
        type: Boolean,
        default: false
      },
      selectedGroup: {
        type: Object,
        default: null
      },
      senders: {
        type: Array,
        default: null
      },
      filterTypes: {
        type: Array,
        default: null
      },
      system: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ""
      },
      selectedClinic: {
        type: Object,
        default: null
      }
    },
    data: () => ({
      username: null,
      FilterEditorHelperMethods,
      snackbar: false,
      notification: "",
      filter1Label: "Filter 1",
      filter2Label: "Filter 2",
      isLoaderActive: false,
      groupData: {},
      filterOptions: [],
      filterTypeId: -1,
      field: {
        name: "",
        senderId: -1,
        filter1Value: "",
        filter2Value: ""
      },
      isFormDirty: false
    }),
    watch: {
      isVisible(val) {
        if (val) {
          console.log('this.filterTypes :>> ', this.filterTypes);
          if (this.filterTypes && this.filterTypes.length) {
            this.filterOptions = this.filterTypes.map((f) => ({
              text: f.GroupFilterType,
              value: f.GroupFilterTypeID
            }));
          }
          this.isFormDirty = false;
          // Dialog opened
          if (this.isEditMode) {
            this.initialize();
          } else {
            // Opening in add mode
            // Reset all fields
            this.field = Object.assign({
              name: "",
              senderId: -1,
            });
            this.filterTypeId = -1
          }
        }
      },
      filterTypeId: function (newVal, oldVal) {
        if (oldVal > -1) {
          this.groupData.GroupDataFilters = [];
        }
      }
    },
    computed: {
      activePractice() {
        if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
          console.log('Dynamic Group Add/Edit dialog computed' + this.$store.state.posActivePractice.value);
          return this.$store.state.posActivePractice.value;
        }
      }
    },
    created() { },
    methods: {
      async initialize() {
        try {
          this.isLoaderActive = true;
          const { data: group } = await Api.dynamicGroup.private.fetchGroup(
            this.selectedGroup.GroupID
          );
          this.groupData = {
            ...group
          };
          this.groupData.GroupDataFilters = FilterEditorHelperMethods.formatGroupFiltersOnLoad(group.GroupDataFilters);
          console.log('group 213333', group)
          // Assign exisiting entry values
          if (this.groupData.Name && this.groupData.Name.length) {
            this.field.name = this.groupData.Name;
          }
          if (this.groupData.GroupFilterTypeID) {
            this.filterTypeId = this.groupData.GroupFilterTypeID;
          }
          console.log("this.groupData 213333", this.groupData);
          console.log('this.groupData.GroupDataFilters 213333', this.groupData.GroupDataFilters)
        } catch (error) {
          console.log("error", error);
        }
        this.isLoaderActive = false;
      },
      _onFilterUpdate(filters) {
        this.groupData.GroupDataFilters = filters;
      },
      close() {
        this.$emit("on-close");
      },
      onFilterSelection() {
        const selectedFilter = this.filterTypes.find(
          f => f.groupFilterTypeID === this.filterTypeId
        );
        if (selectedFilter) {
          this.filter1Label = selectedFilter.filterData1;
          this.filter2Label = selectedFilter.filterData2;
        }
      },
      isFormValid() {
        this.notification = "";
        if (!this.field.name || !this.field.name.length) {
          this.notification = "Provide a group name";
          this.snackbar = true;
          return false;
        }
        if (this.filterTypeId < 0) {
          this.notification = "Select a valid filter type";
          this.snackbar = true;
          return false;
        }
        const validationResult = FilterEditorHelperMethods.validateFilterFields({ filtersData: this.groupData.GroupDataFilters, filterTypeId: this.filterTypeId });
        if (validationResult.hasError) {
          this.notification = validationResult.errorMessage;
          this.snackbar = true;
          return false;
        }
        return true;
      },
      _getPracticeIdFromStore() {
        let practiceId = null;
        if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
          practiceId = this.$store.state.posActivePractice.value;
        }
        return practiceId;
      },
      async submit() {
        this.isFormDirty = true;
        if (!this.isFormValid()) {
          this.snackbar = true;
          return;
        }
        var activePracticeId = this.activePractice;
        if (this.isEditMode) {
          var activegroupId = this.selectedGroup.GroupID;
          // // Update
          var payload = {
            Name: this.selectedGroup.Name,
            PracticeID: this.$store.state.posActivePractice && this.$store.state.posActivePractice.value ? this.$store.state.posActivePractice.value : null,
            GroupFilterTypeID: this.filterTypeId,
            GroupDataFilters: FilterEditorHelperMethods.formatFilterDataPayload(this.groupData.GroupDataFilters)
          };
          if (this.type === "System") {
            payload.System = 1;
          } else if (this.type === "Practice") {
            payload.PracticeID = this.selectedClinic.practice_ID;
          }
          this.$emit("on-submit");
          try {
            await Api.dynamicGroup.private.editDynamicGroup({
              payload: payload,
              groupId: activegroupId
            });
            this.$emit("on-success");
            this.close();
          } catch (error) {
            this.$emit("on-error", error);
          }
        } else {
          // Add
          var payload = {
            TemplateBody: this.field.body,
            Name: this.field.name,
            PracticeID: this.$store.state.posActivePractice && this.$store.state.posActivePractice.value ? this.$store.state.posActivePractice.value : null,
            SenderID: this.field.senderId,
            GroupFilterTypeID: this.filterTypeId,
            GroupDataFilters: FilterEditorHelperMethods.formatFilterDataPayload(this.groupData.GroupDataFilters)
          };
          // if (this.system) {
          //   payload.System = 1
          // }
          if (this.type === "System") {
            payload.System = 1;
          } else if (this.type === "Practice") {
            payload.PracticeID = this.selectedClinic.practice_ID;
          }
          this.$emit("on-submit");
          try {
            await Api.dynamicGroup.private.createDynamicGroup(payload)
            this.$emit("on-success");
            this.close();
          } catch (error) {
            console.log('error', error)
            this.$emit("on-error", error);
          }
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .placeHoldersWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 15px 15px;
    margin-top: 25px;
    margin-bottom: 15px;
    background-color: rgb(116, 116, 116);
    border-radius: 8px;
  }

  .label {
    color: white;
    font-weight: 600;
  }

  .dropdown {
    display: inline-block;
    position: relative;
  }

  .dd-button {
    display: inline-block;
    border: 1px solid gray;
    border-radius: 4px;
    padding: 4px 80px 4px 60px;
    background-color: #ffffff;
    cursor: pointer;
    font-size: 1rem;
    white-space: nowrap;
  }

  .dd-button:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
  }

  .dd-button:hover {
    background-color: #eeeeee;
  }

  .dd-input {
    display: none;
  }

  .dd-menu {
    position: absolute;
    top: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0;
    margin: 0 0 0 0;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    list-style-type: none;
  }

  .dd-input + .dd-menu {
    display: none;
  }

  .dd-input:hover + .dd-menu {
    display: block;
  }

  .dd-menu li {
    width: 180px;
    padding: 0px 20px;
    cursor: pointer;
    white-space: nowrap;
  }

  .dd-menu li:hover {
    background-color: #f6f6f6;
  }

  .dd-menu li a {
    display: block;
    margin: -10px -20px;
    padding: 10px 20px;
  }

  .dd-menu li.divider {
    padding: 0;
    border-bottom: 1px solid #cccccc;
  }

  .v-overlay.v-overlay--active.theme--dark {
    z-index: 200 !important;
  }

  .progressWrapper {
    width: 100%;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;

    .spinner {
      margin-left: 0rem !important;
    }

    flex-direction: column;

    img {
      margin-bottom: 25px;
    }
  }
</style>
